import Default from './default';


const Banner = {
    Default,
   
  };
  
  export default Banner;